import { useEffect } from "react"

export const useTimeoutEffect = (callback: () => unknown, timeout?: number) => {
  useEffect(() => {
    let timeoutId: ReturnType<typeof setTimeout> | undefined
    if (timeout) {
      timeoutId = setTimeout(callback, timeout)
    }
    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId)
      }
    }
  }, [callback, timeout])
}
